import { CustomSerializer } from './custom-serializer';

/**
 * A custom serializer for Date objects. This class converts between Date objects and ISO strings.
 *
 * @class
 * @name DateSerializer
 */
export class DateSerializer extends CustomSerializer {
	deserialize(data: string) {
		return new Date(data);
	}

	serialize(data: Date) {
		return data.toISOString();
	}
}
